const SET_PROPERTY = 'auth/SET_PROPERTY';
const SET_TOKEN = 'auth/SET_TOKEN';
const SET_USER = 'auth/SET_USER';
const SIGN_OUT = 'auth/SIGN_OUT';
const SET_DEVICE = 'auth/SET_DEVICE';

export default {
  SET_PROPERTY,
  SET_TOKEN,
  SET_USER,
  SIGN_OUT,
  SET_DEVICE,
};



// WEBPACK FOOTER //
// ./src/app/auth/store/mutation-types.js